import { Link } from "@nextui-org/react"
import { Text } from "@nextui-org/react"

import { Content } from "../layout/content"

export default ({paths}) => {
    return (
        <>
            <Content contentCss={{marginTop: 0}}>
                {
                    paths.map((path, i) => {
                        if (i === paths.length - 1) {
                            return (<Text key={`path_${i}`} size="$sm" as="span" css={{ml: "5px"}}>{path.value}</Text>)
                        } else {
                            return (
                                <Link 
                                    key={`path_${i}`}
                                    css={{fontSize: "$sm"}}
                                    href={`${path.href}`}
                                    color="text">{`${path.value} > `}</Link>
                            )
                        }
                    })
                }
            </Content>
        </>
    )
}